import React from "react";
import { PageContainer, PageContent, PageHeaders } from "../../components/Layout";
import Form from "./Form";

const SectorNew =() => {
  const action = ["create"];

  return (
    <PageContainer>
      <PageHeaders title="Байгууллагын бүртгэл" />
      <PageContent>
        <Form action={action} />
      </PageContent>
    </PageContainer>
  );
};

export default SectorNew;